<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		components: {
			
		},
		data(){
			return{
				
			}
		},
		
		mounted () {
		
			
			
		},
	}
</script>

<style lang="less">


	#app {
		overflow-x: hidden;
		width: 100%;
		height: 100%;
		font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
			"Microsoft YaHei", "微软雅黑", Arial, sans-serif !important;

		/deep/.el-input__inner,
		/deep/.el-textarea__inner {
			font-size: 14px !important;
			font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
				"Microsoft YaHei", "微软雅黑", Arial, sans-serif !important;
		}

		.el-radio__input.is-checked .el-radio__inner {
			border-color: #409eff;
			background: #FFFFFF;
		}
		.el-radio__input.is-checked .el-radio__inner::after{
			transform: translate(-50%,-50%) scale(1.5);
		}
		.el-radio__inner::after{
			background: #409eff;
		}

		/deep/.el-radio__input.is-checked+.el-radio__label {
			color: #6881ec;
		}

		.btn-gray {
			font-weight: bold;
			color: #999;
			background-color: #f2f2f2;
			border-radius: 4px;
		}

		.btn-white {
			font-weight: bold;
			color: #6881ec;
			background-color: #fff;
			border-color: #6881ec;
			border-radius: 4px;
		}

		.btn-blue {
			font-weight: bold;
			color: #fff;
			background-color: #6881ec;
			border-color: #6881ec;
			border-radius: 4px;
		}

		.btn-orange {
			font-weight: bold;
			color: #fea96c;
			border-radius: 4px;
			background: #fff7e6;
			border: 1px solid #f5daa3;
		}

		.btn-opacity {
			font-weight: bold;
			color: #b9c5e9;
			background-color: #fff;
			border-radius: 4px;
		}

		.right {
			margin-left: auto;
		}

		// 指令性颜色
		.success {
			color: #67c23a;
		}

		.error {
			color: #f56c6c;
		}

		.warn {
			color: #e6a23c;
		}

		.fs12 {
			font-size: 12px;
		}

		.fs14 {
			font-size: 14px;
		}

		.fs16 {
			font-size: 16px;
		}

		.fs30 {
			font-size: 30px;
		}

		.title {
			width: 100%;
			// height: 28px;
			// line-height: 28px;
			// font-size: 18px;
			// font-weight: bold;
			font-size: 15px;
			line-height: 1.5;
			color: #333;
			position: relative;
			padding-left: 15px;
			
			i {
				cursor: pointer;
			}
			
		}
		.title:before{
			content: "";
			position: absolute;
			width: 4px;
			height: 16px;
			background: #46a6ff;
			top: 3px;
			left: 0px;
		}

		//帮助与说明
		.course {
			display: flex;
			flex-direction: column;
			justify-content: center;
			width: calc(100% - 32px);
			padding: 15px;
			background: #fff7e6;
			border-radius: 6px;
			border: 1px solid #f5daa3;
			margin: 15px 0;

			span {
				display: inline-block;
				height: 22px;
			}

			p+p {
				margin-top: 5px;
			}

			.black {
				color: #333;
			}

			.pink {
				color: #f38b93;
			}

			.blue {
				cursor: pointer;
				color: #6881ec;
			}
		}

		.echarts>div:first-child {
			width: 100% !important;
		}

		canvas {
			width: 100% !important;
		}

		// 左侧分组栏
		.el-aside {
			padding: 15px 10px;
			border-radius: 10px;

			.group-main {
				position: relative;
				width: 100%;
				height: 100%;
				overflow-y: auto;
				overflow-x: hidden;

				.el-tree {
					position: absolute;
					min-width: 178px;
					padding-right: 5px;

					.drop-wrap {
						position: absolute;
						right: 20px;
					}
				}
			}

			.el-tree-node>.el-tree-node__children {
				overflow: auto;
			}

			// 树形控件
			/deep/.el-tree-node {
				width: 173px;
				margin: 6px 0;
			}

			.el-tree-node__content {
				height: 40px;
				border-radius: 6px;
			}

			.tree-wrap {
				width: 100%;
				display: flex;
				justify-content: space-between;

				>span {
					width: 120px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}

				.name-wrap {
					display: inline-block;
					width: 100px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
			}

			.active {
				color: #133ab3;
			}

			.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
				background-color: #e5ebfb;
			}
		}

		.el-icon-more {
			font-size: 20px;
		}

		:focus {
			outline: none;
		}


		// // 分页样式
		// .pagination {
		// 	width: 100%;
		// 	margin: 30px 0;

		// 	.el-pagination {
		// 		display: flex;
		// 		align-items: center;
		// 		justify-content: center;
		// 	}
		// }

		// .el-pagination.is-background .el-pager li:not(.disabled).active {
		// 	background-color: #6881ec;
		// }

		// .el-pagination .btn-next,
		// .el-pagination .btn-prev {
		// 	width: 30px;
		// 	height: 30px;
		// 	line-height: 30px;
		// 	text-align: center;
		// 	background: #fff;
		// 	border-radius: 6px;
		// 	padding: 0;
		// 	min-width: 30px;
		// 	margin: 0 5px;
		// 	border: 1px solid rgba(19, 58, 179, 0.2);
		// }

		// .el-pager li {
		// 	width: 30px;
		// 	height: 30px;
		// 	line-height: 30px;
		// 	background: #ffffff;
		// 	border-radius: 6px;
		// 	min-width: 30px;
		// 	border: 1px solid rgba(19, 58, 179, 0.2);
		// 	margin: 0 5px;
		// }

		// 日期选择样式
		.btn-active {
			border-radius: 4px 0 0 4px !important;
		}

		.date-active {
			border-radius: 0 4px 4px 0 !important;
			border-color: #6881ec !important;
			border-left: none;
		}

		.date-active-left .el-input__inner {
			border-radius: 0 4px 4px 0 !important;
			border-color: #6881ec;
		}

		.date-active-center .el-input__inner {
			border-radius: 0px !important;
			border-color: #6881ec;
			border-right: none;
		}
		
		.el-main {
			width: 100%;
			height: 100%;
			padding: 15px;
			margin-left: 15px;
			background: #FFFFFF;
			box-shadow: 0px 0px 12px 0px rgba(47, 75, 168, 0.06);
			border-radius: 12px;
		}

	}
	
	.el-popconfirm__action{
		margin-top: 10px !important;
	}
	
	.wl-treeselect-popover{
		height: auto !important;
		
		.el-scrollbar__view{
			max-height: 250px;
		}
	}
	

	
	
	/* 点击验证 */
	.vue-auth-box_{
		max-width: 310px;
		width: 80%;
	}
	
	/* message 弹出 */
	.el-message{
		max-width: 380px;
		min-width: auto !important;
		width: 85%;
	}
	.el-image-viewer__wrapper{z-index:11111!important;}
	.el-input--mini .el-input__inner {
  height: 45px!important;
  line-height: 45px!important;font-size: 16px;
}
.disabled .el-upload--picture-card {
								visibility: hidden;
                display:none;
							}
</style>
